import axios from "axios";
import { store } from "../../redux/store";
import { setUserAuth, setRequestSignature } from "../../redux/slices/authSlice";
import { setStatusPopup } from "../../redux/slices/statusPopupSlice";
import { persistor } from "../../redux/store";
import { ROUTES } from "../../../routes/routerConfig";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = store?.getState()?.auth?.token;
    if (token) {
      config.headers.Authorization = token;
    }

    config.headers["application-type"] = "Assisted";

    config.headers["x-channel"] = "assisted";
    // Only set Content-Type to application/json if the data is not FormData
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }
    // For FormData, let the browser set the Content-Type with boundary automatically
    //config.headers["x-channel"] ="assisted";
    if(!token){
      //config.headers["x-api-key"] = process.env.REACT_APP_X_API_KEY;
    }

    // Add x-request-signature from auth store (captured from /assisted/login response)
    const requestSignature = store?.getState()?.auth?.requestSignature;
    if (requestSignature) {
      config.headers["x-request-signature"] = requestSignature;
    }

    // You can modify request headers or perform other operations before sending the request
    // For example, you can add authentication tokens if needed
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    if (response?.headers?.["x-new-token"]) {
      if (
        store?.getState()?.auth?.token !== response?.headers?.["x-new-token"]
      ) {
        store?.dispatch(setUserAuth(response?.headers?.["x-new-token"]));
      }
    }

    // Capture x-request-signature from /assisted/login response and save to Redux
    const isAssistedLogin = response?.config?.url?.includes("assisted/login");
    const signature =
      response?.headers?.["x-request-signature"] ??
      response?.headers?.["X-Request-Signature"];
    if (isAssistedLogin && signature) {
      store?.dispatch(setRequestSignature(signature));
    }

    // Any status code that lies within the range of 2xx causes this function to trigger
    // You can modify response data before it's returned
    return response;
  },
  (error) => {
    // Any status codes that fall outside the range of 2xx cause this function to trigger
    // Handle error responses
    if (error?.response?.status === 409) {
      sessionStorage?.clear();
      localStorage.removeItem("selectedIndex");
      // store.dispatch({ type: PURGE, key: 'root' });
      store.dispatch(
        setStatusPopup({
          status: "error",
          message: error?.response?.data?.message,
          anotherDeviceAuth: true,
        })
      );
      setTimeout(() => {
        persistor.purge(); // ✅ c
      }, 1000); // wait for UI to render popup
      return Promise.reject(error);
    } else if (error?.response?.status === 401) {
      // store.dispatch(setStatusPopup({
      //   status: "info",
      //   message:
      //     "Your session has been expired. Please login again.",
      //   isFunction: true,
      //   locationFunction: () => {
      //     window.location.href = ROUTES.Base.notFound;
      //   },
      // }));
      store.dispatch(setStatusPopup({
        status: "info",
        message: "Your session has been expired. Click OK to return to the previous page.",
        isFunction: true,
        isShowCloseIcon: "NO",
        locationFunction: () => {
          window.history.back();
        },
      }));
      sessionStorage?.clear();
      localStorage.removeItem("selectedIndex");
      store.dispatch({ type: "selectedIndex/reset" });
      setTimeout(() => {
        persistor.purge(); // ✅ c
      }, 1000);
      // window.location.href = "/login";
    } else {
      return Promise.reject(error);
    }
  }
);

export default axiosInstance;
